export enum TextSearchQueryParam {
	SearchTerm = 'searchTerm',
	SearchBy = 'searchBy',
}
